module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('DDropdown', {
    attrs: {
      "isShowDots": false,
      "isBottomStart": false,
      "propOffset": [5, 5]
    }
  }, [_c('button', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        arrow: true,
        animateFill: false,
        animation: 'shift-away',
        zIndex: '999999992',
        boundary: 'window',
        trigger: 'click'
      }),
      expression: "{\n              arrow: true,\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window',\n              trigger : 'click'\n            }"
    }],
    staticClass: "do-bttn",
    attrs: {
      "slot": "title",
      "content": _vm.$t('vue.deleteday.delete_day_or_week')
    },
    slot: "title"
  }, [_c('span', {
    staticClass: "icon-bin"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-arrow-down5"
  })]), _vm._v(" "), _c('ul', {
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, [_c('li', {
    staticClass: "d-item-warning",
    on: {
      "click": function($event) {
        return _vm.setIsConfirmDeletion('week')
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('vue.deleteday.whole_week')) + "\n      ")]), _vm._v(" "), _vm._l((_vm.weekDays), function(day) {
    return _c('li', {
      staticClass: "capitalize",
      on: {
        "click": function($event) {
          return _vm.setIsConfirmDeletion(day)
        }
      }
    }, [_vm._v("\n        " + _vm._s(day.name) + "\n      ")])
  })], 2)]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "d-modal"
    }
  }, [(_vm.isConfirmDeletion) ? _c('ModalConfirmation', {
    attrs: {
      "showClose": false,
      "isSubmitButtonLoading": _vm.isDeleting
    },
    on: {
      "close": _vm.closeIsConfirmDelete,
      "confirm": _vm.onConfirmDelete
    }
  }, [_c('h3', {
    attrs: {
      "slot": "item"
    },
    slot: "item"
  }, [_vm._v(_vm._s(_vm.theDeleteText))])]) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2be6e1c6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DCalendar/DCalendarHeaderDelete.vue
// module id = 1506
// module chunks = 1